// extracted by mini-css-extract-plugin
export default {"skipLinkContainer":"skip_link-module___skipLinkContainer___ae390122","skipLink":"skip_link-module___skipLink___dd737e2b"};